import React        from "react";
import { Box }      from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PSIAppBar    from "../AppBar";

const DashboardLayout = ({
  tabs        = [],
  activeTab,
  onTabChange,
  macBadge,
  children,
}) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      height:        "100vh",       // fixed — no overflow
      background:    t.bg,
      display:       "flex",
      flexDirection: "column",
      overflow:      "hidden",      // prevent page-level scroll
    }}>
      <PSIAppBar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        macBadge={macBadge}
      />

      {/* main fills remaining height exactly — children must manage their own scroll */}
      <Box
        component="main"
        sx={{
          flex:          1,
          display:       "flex",
          flexDirection: "column",
          overflow:      "hidden",  // children scroll internally, not the page
          minHeight:     0,         // flex child must have minHeight 0 to shrink
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DashboardLayout;